// extracted by mini-css-extract-plugin
module.exports = {"checkout-button":"checkout-button_checkout-button__I0Cdn","checkout-button-terms":"checkout-button_checkout-button-terms__Dm_5E"};